import React, { useCallback, useMemo, useState } from 'react';
import { useAllowHousingStock } from '../../../../shared/hooks/allowHousingStock';
import { useOpenAddTenantModal } from '../../../../controllers/AddTenant';
import {
  registrationStateTypes,
  useRegistrationControllers,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import { createRoomAddress } from '../../../../shared/packages/address';
import OwnersDropdown from '../../ui/OwnersDropdown';

const emptyProps = {};

export const useAddOwnerSelectProps = () => {
  const allowHousingStock = useAllowHousingStock();

  const room = useRegistrationSubscribe({
    type: registrationStateTypes.address,
    selector: (payload) => payload.value,
  });

  const { refetchOwners } = useRegistrationControllers();
  const openAddTenantModal = useOpenAddTenantModal();

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const handleAdd = useCallback(() => {
    if (!room?.id) return;

    setDropdownOpen(false);
    openAddTenantModal({
      addressId: room.id,
      address: createRoomAddress(room),
      onSuccess: (client) => refetchOwners(client.id),
    });
  }, [room, openAddTenantModal, refetchOwners]);

  const dropdownRender = useCallback(
    (menu) => <OwnersDropdown menu={menu} onAdd={handleAdd} />,
    [handleAdd]
  );

  const canAdd = Boolean(allowHousingStock && room?.id);

  return useMemo(
    () =>
      canAdd
        ? {
            open: isDropdownOpen,
            onDropdownVisibleChange: setDropdownOpen,
            dropdownRender,
          }
        : emptyProps,
    [canAdd, isDropdownOpen, dropdownRender]
  );
};
